import { screenNames } from "clientState/AuthFlow/providers/ScreenProvider";
import { type ScreenNameType } from "clientState/AuthFlow/providers/ScreenProvider/contract";

import { EVENT_ACTION, EVENT_CATEGORY } from "./constants";
import { type TrackingFunction } from "./contract";

const { SIGNIN, SIGNUP } = screenNames;

export const withPrefix = (main: string, prefix?: string): string =>
  prefix ? `${prefix}_${main}` : main;

export const trackClosed: TrackingFunction = ({
  trackEvent,
  screen,
  prefix,
}) => {
  trackEvent?.({
    category: EVENT_CATEGORY,
    action: EVENT_ACTION.LOGIN,
    label: withPrefix(`${screen}_close`, prefix),
  });
};

export const trackLoaded: TrackingFunction = ({
  trackEvent,
  screen,
  prefix,
}) => {
  trackEvent?.({
    category: EVENT_CATEGORY,
    action: EVENT_ACTION.LOGIN,
    label: withPrefix(`${screen}_onload`, prefix),
  });
};

export const trackStarted: TrackingFunction = ({
  trackEvent,
  screen,
  isEmail = false,
  isGoogle = false,
  prefix,
}) => {
  trackEvent?.({
    category: EVENT_CATEGORY,
    action: EVENT_ACTION.LOGIN,
    label: withPrefix(
      `${screen}_${isEmail ? "email_" : ""}${isGoogle ? "google_" : ""}start`,
      prefix,
    ),
  });
};

export const trackError: TrackingFunction = ({
  trackEvent,
  screen,
  isEmail = false,
  isGoogle = false,
  prefix,
}) => {
  trackEvent?.({
    category: EVENT_CATEGORY,
    action: EVENT_ACTION.LOGIN,
    label: withPrefix(
      `${screen}_${isEmail ? "email_" : ""}${isGoogle ? "google_" : ""}error`,
      prefix,
    ),
  });
};

export const trackSuccess: TrackingFunction = ({
  trackEvent,
  screen,
  isEmail = false,
  isGoogle = false,
  prefix,
}) => {
  trackEvent?.({
    category: EVENT_CATEGORY,
    action: EVENT_ACTION.LOGIN,
    label: withPrefix(
      `${screen}_${isEmail ? "email_" : ""}${isGoogle ? "google_" : ""}success`,
      prefix,
    ),
  });
};

export const trackClick: TrackingFunction = ({
  trackEvent,
  screen,
  prefix,
}) => {
  const toScreen = {
    [SIGNIN]: `-to-${SIGNUP}`,
    [SIGNUP]: `-to-${SIGNIN}`,
  } as Readonly<Record<ScreenNameType, string>>;

  const destinationScreen = toScreen[screen] ?? "";

  trackEvent?.({
    category: EVENT_CATEGORY,
    action: EVENT_ACTION.LOGIN,
    label: withPrefix(`${screen}_click${destinationScreen}`, prefix),
  });
};

export const triggerTrackingClick = (id: string): void => {
  window.document.getElementById(id)?.click();
};
